import React, { Component } from 'react';
//import _ from 'lodash';
import { Modal, Input } from 'semantic-ui-react';
import $ from 'jquery';
//import { observer, inject } from 'mobx-react';
//import WithRouter from '../Extensions/WithRouter';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';
import ResultRenderer from '../ResultRenderer/ResultRenderer';

class MoveFileModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isShowResult: false,
      currentPage: 1,
      pageSize: 6,
      rowData: props.rowData,
      isOpenMFM: props.isOpenMFM,
      selectedProject: {
        id: '', name: '',
      },
      selectedProjectVersion: {
        id: '', name: '',
      },
      projectList: [],
      projectVersionList: [],
    };
    this.closeModal = this.closeModal.bind(this);
    this.handleResultSelect = this.handleResultSelect.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchFocus = this.handleSearchFocus.bind(this);
    this.hanldeProjectScroll = this.hanldeProjectScroll.bind(this);
    this.handleResultSelectVersion = this.handleResultSelectVersion.bind(this);
    this.handleSearchVersionChange = this.handleSearchVersionChange.bind(this);
    this.handleSearchVersionFocus = this.handleSearchVersionFocus.bind(this);
    this.hanldeProjecVersiontScroll = this.hanldeProjecVersiontScroll.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.getReportedProjectList = this.getReportedProjectList.bind(this);
    this.getReportedProjectVersionList = this.getReportedProjectVersionList.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.popup_content .popup_content_item .text_area', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    const { isOpenMFM, rowData } = this.props;
    if (prevProps.isOpenMFM !== isOpenMFM) {
      this.setState({
        projectList: [],
        selectedProject: {
          id: '', name: '',
        },
        projectVersionList: [],
        selectedProjectVersion: {
          id: '', name: '',
        },
        isShowResult: false,
        isOpenMFM,
      });
    }

    if (prevProps.rowData !== rowData) {
      this.setState({
        rowData,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    const { selectedProject } = this.state;
    if (this.projectName && !this.projectName.contains(event.target)) {
      this.setState({
        isShowResult: false,
        projectList: [],
        isLoading: false,
        currentPage: 1,
      }, () => {
        if (!selectedProject.id) {
          this.setState({
            selectedProjectVersion: {
              id: '', name: '',
            },
          });
        }
      });
    }

    if (this.projectVersionName && !this.projectVersionName.contains(event.target)) {
      this.setState({
        isShowResultforVer: false,
        projectVersionList: [],
        isLoadingforVer: false,
        currentPage: 1,
      });
    }
  }

  handleSearchFocus() {
    setTimeout(() => {
      this.setState({
        projectList: [],
        isLoading: false,
      }, () => {
        this.getReportedProjectList();
      });
    }, 300);

    this.setState({
      isShowResult: true,
    });
  }

  handleSearchVersionFocus() {
    setTimeout(() => {
      this.setState({
        projectVersionList: [],
        isLoadingforVer: false,
      }, () => {
        this.getReportedProjectVersionList();
      });
    }, 300);

    this.setState({
      isShowResultforVer: true,
    });
  }

  onSubmit() {
    const { selectedProject, selectedProjectVersion } = this.state;
    const { rowData, setFileMove } = this.props;
    const obj = {
      selectedProject,
      selectedProjectVersion,
      rowData,
    };
    const uid = rowData.uid || rowData.uploaded_file_id;
    setFileMove(obj, uid);
  }

  getReportedProjectList(pageNo, limit) {
    const { selectedProject, pageSize, projectList } = this.state;
    const page = pageNo || 1;
    const perPage = limit || pageSize;

    this.setState({
      isLoading: true,
    }, () => {
      api.getReportedProjectList(
        {
          search: selectedProject.name,
          page,
          limit: perPage,
        }
      )
        .then((response) => {
          if (projectList.length !== 0 && response.pagination.current === 1) {
            return false;
          }
          const nextProjectList = response.response.map((item) => {
            return {
              id: item.id,
              name: item.name,
            };
          });

          this.setState({
            isLoading: false,
            currentPage: response.pagination.current,
            hasMore: response.pagination.next !== null,
            projectList: [...projectList, ...nextProjectList],
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  getReportedProjectVersionList(pageNo, limit) {
    const {
      selectedProjectVersion, selectedProject, pageSize, projectVersionList
    } = this.state;
    const page = pageNo || 1;
    const perPage = limit || pageSize;

    this.setState({
      isLoading: true,
    }, () => {
      api.getReportedProjectVersionList(
        {
          search: selectedProjectVersion.name,
          page,
          limit: perPage,
        },
        selectedProject.id,
      )
        .then((response) => {
          if (projectVersionList.length !== 0 && response.pagination.current === 1) {
            return false;
          }
          const nextProjectVersionList = response.response.map((item) => {
            return {
              id: item.id,
              name: item.name,
            };
          });

          this.setState({
            isLoading: false,
            currentPage: response.pagination.current,
            hasMore: response.pagination.next !== null,
            projectVersionList: [...projectVersionList, ...nextProjectVersionList],
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  hanldeProjectScroll = (event) => {
    const {
      getReportedProjectList,
      state: {
        error, hasMore, isLoading, currentPage
      },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrolledToBottom) {
      getReportedProjectList(currentPage + 1);
    }
  };

  hanldeProjecVersiontScroll = (event) => {
    const {
      getReportedProjectVersionList,
      state: {
        error, hasMore, isLoadingforVer, currentPage
      },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (error || isLoadingforVer || !hasMore) {
      return;
    }
    if (scrolledToBottom) {
      getReportedProjectVersionList(currentPage + 1);
    }
  };

  handleResultSelect = (e, result) => {
    this.setState({
      selectedProject: {
        id: result.id,
        name: result.name,
      },
      selectedProjectVersion: {
        id: '', name: '',
      },
      isShowResult: false,
      isLoading: false,
      projectList: [],
    });
  };

  handleResultSelectVersion = (e, result) => {
    this.setState({
      selectedProjectVersion: {
        id: result.id,
        name: result.name,
      },
      isLoadingforVer: false,
      isShowResultforVer: false,
      projectVersionList: [],
    });
  };

  handleSearchChange = (e, { value }) => {
    this.setState({
      isLoading: true,
      selectedProject: {
        id: '',
        name: value,
      },
      projectList: [],
    });

    setTimeout(() => {
      if (value.length < 1) {
        value = '';
        return this.setState({
          selectedProject: {
            id: '', name: '',
          },
          isLoading: false,
        });
      }
      this.getReportedProjectList();
    }, 300);
  };

  handleSearchVersionChange = (e, { value }) => {
    this.setState({
      isLoadingforVer: true,
      selectedProjectVersion: {
        id: '',
        name: value,
      },
      projectVersionList: [],
    });

    setTimeout(() => {
      if (value.length < 1) {
        value = '';
        return this.setState({
          selectedProjectVersion: {
            id: '', name: '',
          },
          isLoadingforVer: false,
        });
      }
      this.getReportedProjectVersionList();
    }, 300);
  };

  closeModal(e) {
    const { closeModal } = this.props;
    e.preventDefault();
    //|| e.target.classList.value === 'ui page modals dimmer transition visible active'
    if (e.target.classList.value === 'ui message content' || e.target.classList.value === 'result') {
      return null;
    }
    closeModal();
  }

  render() {
    const {
      rowData,
      isLoading,
      isLoadingforVer,
      projectList,
      isShowResult,
      isShowResultforVer,
      projectVersionList,
      selectedProject,
      selectedProjectVersion,
      isOpenMFM,
    } = this.state;

    const {
      isMovingFile, projectName, translate
    } = this.props;

    const getModalContent = () => {
      if (isMovingFile) {
        return (
          <div className="modal_popup_wrap move_file_wrap">
            <div className="modal_popup_box move_file_box">
              <div className="modal_popup move_file">
                <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                  <Loader
                    style={{
                      position: 'relative',
                      width: '80%',
                      height: '80%',
                      marginBottom: '15%',
                    }}
                  />
                  <span
                    style={{
                      fontWeight: '500',
                      fontSize: '16px',
                      marginTop: '35%',
                      display: 'inline-block',
                    }}
                  >
                    {translate('modal.message.prepare_report_move')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div className="modal_popup_wrap move_file_wrap">
          <div className="modal_popup_box move_file_box">
            <div className="modal_popup move_file">
              <h2 className="title">
                {translate('modal.title.move_scan_result')}
                <em>{rowData.name}</em>
                <a className="close_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                  <img src={closeBtn} alt="" />
                </a>
              </h2>
              <div className="popup_content">
                <div className="popup_content_item">
                  <h3>{translate('modal.title.current_location')}</h3>
                  <p className="text_area">
                    <span>{rowData.projectName || projectName}</span>
                    <span>/</span>
                    <span>{rowData.projectVersionName || rowData.project_version_name}</span>
                  </p>
                </div>
                <div className="popup_content_item">
                  <h3>{translate('modal.title.select_location_change')}</h3>
                  <div className="select_area_wrap">
                    <div
                      className="select_area custom"
                      ref={(ref) => {
                        this.projectName = ref;
                      }}
                    >
                      <Input
                        icon="search"
                        loading={isLoading}
                        placeholder={translate('modal.place_holder.search_project_name')}
                        value={selectedProject.name}
                        onChange={this.handleSearchChange}
                        onFocus={this.handleSearchFocus}
                      />
                      <ResultRenderer
                        results={projectList}
                        handleResultSelect={this.handleResultSelect}
                        isShowResult={isShowResult}
                        hanldeProjectScroll={this.hanldeProjectScroll}
                        translate={translate}
                      />
                    </div>
                    <div
                      className="select_area custom"
                      ref={(ref) => {
                        this.projectVersionName = ref;
                      }}
                    >
                      <Input
                        icon="search"
                        loading={isLoadingforVer}
                        placeholder={translate('modal.place_holder.search_project_version_name')}
                        value={selectedProjectVersion.name}
                        onChange={this.handleSearchVersionChange}
                        onFocus={this.handleSearchVersionFocus}
                        disabled={!selectedProject.id}
                      />
                      <ResultRenderer
                        results={projectVersionList}
                        handleResultSelect={this.handleResultSelectVersion}
                        isShowResultforVer={isShowResultforVer}
                        hanldeProjectScroll={this.hanldeProjecVersiontScroll}
                        translate={translate}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="button_wrap">
                <a className="left_button" onClick={this.closeModal} onKeyUp={this.closeModal}>{translate('modal.button.cancel')}</a>
                {
                  selectedProject.id && selectedProjectVersion.id ? (
                    <a className="right_button" onClick={this.onSubmit} onKeyUp={this.onSubmit}>{translate('modal.button.save')}</a>
                  ) : (
                    <a className="right_button" style={{ pointerEvents: 'none', opacity: '0.5' }}>{translate('modal.button.save')}</a>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      );
    };
    return (
      <Modal open={isOpenMFM} onClose={this.closeModal}>
        {getModalContent()}
      </Modal>
    );
  }
}

export default MoveFileModal;
